// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"signature__msignaturepad___31XWY","m-signature-pad--body":"signature__m-signature-pad--body___JiAkr","m-signature-pad--footer":"signature__m-signature-pad--footer___8XcVY","description":"signature__description___1D6fs","button":"signature__button___OKtoe","clear":"signature__clear___lueAz","save":"signature__save___3hstm","m-signature-pad":"signature__m-signature-pad___1zIjF","github":"signature__github___I32TT","SignaturePad":"signature__SignaturePad___2XthH"};


//////////////////
// WEBPACK FOOTER
// ./client/app/shared/styles/signature.css
// module id = uhZm
// module chunks = client